import { IQService, IScope, ITimeoutService, IWindowService } from "angular";
import { parseJSON } from "date-fns";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { Match } from "../../interfaces/match.interface";
import { BetService } from "../../services/bet.service";
import { GeneralService } from "../../services/general.service";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

export class GameBarController {

	configurationObject: BlockConfigurationObject;
	displayMode = "full";
	gameBarSports: Array<string> = [];
	gamesError = false;
	gamesLoading = true;
	generalService: GeneralService;
	liveDataTimeout = null;
	matches: Array<Match> = [];
	matchService: MatchService;
	midGrab = false;
	selectedSport = "all";
	shiftElementCount = 0;
	shiftPixelCount = 0;
	smoothScrolling = true;

	// _Rollbar: any;
	_$window: IWindowService;
	_$timeout: ITimeoutService;
	_sportDataService: SportDataService;
	_betService: BetService;
	_$q: IQService;
	_$scope: IScope;

	grabStartPos: Record<string, number> = {left: 0, x: 0};
	displayMaximumWidths: Record<string, number> = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
	};

	/* @ngInject */
	constructor($scope: IScope, /*Rollbar: any,*/ $window: IWindowService, $q: IQService,
		$timeout: ITimeoutService, configurationObject: BlockConfigurationObject, matchService: MatchService,
		sportDataService: SportDataService, generalService: GeneralService, betService: BetService, public cdnDomain: string) {

		//$controller("externalBlocks");

		this.generalService = generalService;
		this.matchService = matchService;

		// this._Rollbar = Rollbar;
		this._$window = $window;
		this._$timeout = $timeout;
		this.configurationObject = configurationObject;
		this._sportDataService = sportDataService;
		this._betService = betService;
		this._$scope = $scope;

		generalService.initialiseBlock();
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

		$window.addEventListener("resize", this.checkCompact);
		
		this.gameBarSports = configurationObject.sports.map(s => s.toUpperCase());

		$q.when(matchService.getGeoData()).then(() => {
			this.retrieveGames();
		}, () => {
			this.retrieveGames();
		});	

		this._$scope.$on("destroy", function() {
			if (this.liveDataTimeout) {
				this._$timeout.cancel(this.liveDataTimeout);
				this.liveDataTimeout = null;
			}
			
		});
		const blockParent = document.getElementById(this.configurationObject.targetElementID).parentNode;
		new MutationObserver(() => {
			if (blockParent.querySelector("#" + this.configurationObject.targetElementID) === null) {
				if (this.liveDataTimeout) {
					this._$timeout.cancel(this.liveDataTimeout);
					this.liveDataTimeout = null;
				}
			}
		}).observe(document.getElementById(this.configurationObject.targetElementID).parentNode, {childList: true, subtree: true});
	}

	gameBarSportOptions = (): Array<string> => {
		return this.gameBarSports
			.filter((sport: string) => this.matches
				.some(this.matchService.matchFitsFilter(sport,
					this.configurationObject.forwardHours,
					this.configurationObject.backwardHours)))
			.sort((a,b) => {
				const topAGame = this.matches.filter(this.matchService.matchFitsFilter(a,
					this.configurationObject.forwardHours,
					this.configurationObject.backwardHours))
					.sort((a,b) => this.matchService.gameDisplaySort(a,b))[0];
				const topBGame = this.matches.filter(this.matchService.matchFitsFilter(b,
					this.configurationObject.forwardHours,
					this.configurationObject.backwardHours))
					.sort((a,b) => this.matchService.gameDisplaySort(a,b))[0];

				return this.matchService.gameDisplaySort(topAGame, topBGame);
			});
				
	}

	
	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});
		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
		
	}

	resetShift = (): void => {
		this.smoothScrolling = false;
		this.shiftElementCount = 0;
		document.getElementById("si-game-track").scrollLeft = 0;
		this.smoothScrolling = true;
	}

	shiftLeft = (): void => {
		if (this.shiftElementCount > 0) {
			const incrementLength = (document.getElementById("si-game-track").querySelectorAll(".sport-group-header, .game-link, .bookie-attr")[this.shiftElementCount - 1] as HTMLElement).offsetWidth;
			this.shiftElementCount--;
			document.getElementById("si-game-track").scroll({
				left: document.getElementById("si-game-track").scrollLeft - incrementLength,
				behavior: "smooth"
			});
		}
	}

	shiftRight = (): void => {
		if (this.shiftElementCount < (document.getElementById("si-game-track").querySelectorAll(".sport-group-header, .game-link, .bookie-attr").length - 1)) {
			const incrementLength = (document.getElementById("si-game-track").querySelectorAll(".sport-group-header, .game-link, .bookie-attr")[this.shiftElementCount] as HTMLElement).offsetWidth;
			if ((document.getElementById("si-game-track").scrollLeft + incrementLength) <= document.getElementById("si-game-track").scrollWidth) {
				this.shiftElementCount++;
				document.getElementById("si-game-track").scroll({
					left: document.getElementById("si-game-track").scrollLeft + incrementLength,
					behavior: "smooth"
				});
			}
		}
	}

	startGrab = (e: MouseEvent): void => {
		this.grabStartPos = {left: document.getElementById("si-game-track").scrollLeft, x: e.clientX};
		document.addEventListener("mousemove", this.grabMove);
		document.addEventListener("mouseup", this.endGrab);
	}

	grabMove = (e: MouseEvent): void => {
		this.midGrab = true;
		const dx = e.clientX - this.grabStartPos.x;

		document.getElementById("si-game-track").scrollLeft = this.grabStartPos.left - dx;
	}

	endGrab = (e: MouseEvent): void => {
		// if the action was a straight click instead of a drag, go through to the link of that tile
		if (!this.midGrab && (e.target as Element).closest("[href]") !== null && e.button === 0) {
			if (this.configurationObject.linkCallback) {
				this.configurationObject.linkCallback((e.target as Element).closest("[href]").getAttribute("href"));
			} else {
				this._$window.location.href = ((e.target as Element).closest("[href]") as HTMLElement).getAttribute("href");
			}
		}
		
		this.midGrab = false;

		let cumulativeWidth = 0, i = 0;

		while (i < document.getElementById("si-game-track").querySelectorAll(".sport-group-header, .game-link, .bookie-attr").length && cumulativeWidth <= document.getElementById("si-game-track").scrollLeft) {
			i += 1;
			cumulativeWidth += (document.getElementById("si-game-track").querySelectorAll(".sport-group-header, .game-link, .bookie-attr")[i] as HTMLElement).offsetWidth;
		}

		this.shiftElementCount = i - 1;

		document.removeEventListener("mousemove", this.grabMove);
		document.removeEventListener("mouseup", this.endGrab);
	}

	tileClick = (e: MouseEvent): void => {
		// don't let the link be accidentally clicked through to on click-and-drags (genuine clicks will be handled by endGrab)
		e.preventDefault();
	}

	updateLiveData = (): void => {
		let bookmakerList: Array<string> = [];
		if (this.configurationObject.bookmakers) {
			bookmakerList = this.configurationObject.bookmakers;
		} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
			if (this.configurationObject.bookmakerThemeSportExceptions) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme, "tab"];
			} else {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
		}
		this._sportDataService.getUpcomingGames(this.gameBarSports, true, true, bookmakerList, this.configurationObject.sportExclusiveBookmakers)
			.then(matches => {
				const existingMatchList: Match[] = this.matches.slice();
				const newMatchList: Match[] = matches.filter((g: Match) => this.gameBarSports.includes(g.MatchData.Sport.toUpperCase()));
				
				newMatchList.forEach(match => {
					if (existingMatchList.some(m => m.MatchData.SIMatchID === match.MatchData.SIMatchID)) {
						const oldMatchData = existingMatchList.find(m => m.MatchData.SIMatchID === match.MatchData.SIMatchID);
						if (oldMatchData.LiveData !== match.LiveData) {
							if (oldMatchData.LiveData && match.LiveData) {
								if (oldMatchData.LiveData.homeScore !== match.LiveData.homeScore
									|| oldMatchData.LiveData.homeRuns !== match.LiveData.homeRuns
									|| oldMatchData.LiveData.homeWickets !== match.LiveData.homeWickets) {
									oldMatchData.homeScoreJustChanged = true;
									this._$timeout(() => oldMatchData.homeScoreJustChanged = false, 1000);
								}
		
								if (oldMatchData.LiveData.awayScore !== match.LiveData.awayScore
									|| oldMatchData.LiveData.awayRuns !== match.LiveData.awayRuns
									|| oldMatchData.LiveData.awayWickets !== match.LiveData.awayWickets) {
									oldMatchData.awayScoreJustChanged = true;
									this._$timeout(() => oldMatchData.awayScoreJustChanged = false, 1000);
								}

							}

							oldMatchData.LiveData = match.LiveData;
						}
					} else {
						match.MatchData.UserDate = parseJSON(match.MatchData.Date);
						this._betService.populateTileBettingInfo(match);
						existingMatchList.push(match);
					}
				});

				existingMatchList.sort((a,b) => this.matchService.gameDisplaySort(a,b));

				this.matches = existingMatchList;

				// if the current selected sport is no longer available because its games have dropped off, revert to showing All games
				if (this.selectedSport !== "all" && !existingMatchList.some(m => m.MatchData.Sport.toLowerCase() === this.selectedSport)) {
					this.selectedSport = "all";
				}

				//replaceCarouselGames(existingMatchList);
				//vm.carousel.refresh();

				this.liveDataTimeout = this._$timeout(this.updateLiveData, 30000);
			})
			.catch((err) => {
				if (err !== "API_CALL_FAILED") {
					// this._Rollbar.error(err);
					console.error(err);
				}
			});
	}

	retrieveGames = (): void => {
		this.gamesLoading = true;
		this.gamesError = false;
		let bookmakerList: Array<string> = [];
		if (this.configurationObject.bookmakers) {
			bookmakerList = this.configurationObject.bookmakers;
		} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
			if (this.configurationObject.bookmakerThemeSportExceptions) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme, "tab"];
			} else {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
		}
		this._sportDataService.getUpcomingGames(this.gameBarSports, true, true, bookmakerList, this.configurationObject.sportExclusiveBookmakers)
			.then(matches => {
				this.matches = matches.filter(g => this.gameBarSports.includes(g.MatchData.Sport.toUpperCase()));
					
		
				this.matches.forEach((match: Match) => {
					match.MatchData.UserDate = parseJSON(match.MatchData.Date);
					match.homeScoreJustChanged = false;
					match.awayScoreJustChanged = false;
					this._betService.populateTileBettingInfo(match);
				});

				this.matches.sort((a,b) => this.matchService.gameDisplaySort(a,b));
		
				this.gamesLoading = false;

				this.liveDataTimeout = this._$timeout(this.updateLiveData, 30000);
			})
			.catch((err) => {
				if (err !== "API_CALL_FAILED") {
					// this._Rollbar.error(err);
					console.error(err);
				}
				this.gamesError = true;
			});
	}

	reloadGames = (): void => {
		this.retrieveGames();
	}
}